import '@fontsource-variable/cairo';
import '@fontsource-variable/public-sans';
// Amiri 700 — used only for the small "المنار" calligraphic pill on /about.
import '@fontsource/amiri/700.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './locales/i18n';
import { App } from './app';
import './global.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
